export enum 入力状態 {
  未表示 = '未表示',
  未確定表示中_明細なし = '未確定表示中_明細なし',
  未確定表示中_明細あり = '未確定表示中_明細あり',
  確定済表示中_明細なし = '確定済表示中_明細なし',
  確定済表示中_明細あり = '確定済表示中_明細あり',
}
